/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        06/02/2020 16:19
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import 'slick-carousel/slick/slick.min';

export default class Slider
{
    static #slick_element = [];
    
    constructor()
    {
        Slider.initializeSlider();
        Slider.updateCurrentSliderFrontPage();
    }
    
    static initializeSlider()
    {
        const slider = $( '[js-slick]' );
        
        if ( slider.length > 0 ) {
            slider.each(function( index ) {
                Slider.#slick_element[index] = $( this ).slick();
            });
        }
    }
    
    static updateCurrentSliderFrontPage()
    {
        if ( Slider.#slick_element !== [] ) {
            for (let i = 0; i < Slider.#slick_element.length ; i++) {
                Slider.#slick_element[i].on( 'afterChange', function( slick, currentSlide ) {
                    let index = currentSlide.currentSlide + 1;
                    if ( index < 10 ) {
                        index = "0" + index;
                    }
                    Slider.#slick_element[i].next().find(".counterCurrent").html( index );
                } );
            }
        }
    }
}
